import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IMeetingDetails } from "../../../api/IMeeting";
import { ILicenceProfile } from "../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  meetingDetails: IMeetingDetails;
}

const BreadCrumbs = ({ licenceProfile, meetingDetails }: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{meetingDetails.reference}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
